import { Component, Input, ViewChild } from "@angular/core";
import { FormGroup } from '@angular/forms';
import { NgbDateNativeAdapter, NgbDatepicker, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import moment from "moment";
import { NgbLocalDateParserFormatter } from './ngb-local-date-parser-formatter';


@Component({
  standalone: false,
  selector: 'app-popup-date-picker',
  template: `
  <div [formGroup]="formGroup">
    <div [formGroupName]="fGroupName">
      <fieldset [formGroupName]="fieldSetName">
          <div class="input-group">
            <input sdInputMask maxlength="11" class="form-control  {{extraCss}}" [formControlName]="fControlName" [placeholder]="placeholder"
             [readonly]="readonly" [ngStyle]="{'background-color':'#ffffff'}"
              [minDate]="convert(minDate)" [maxDate]="convert(maxDate)" [value]="value"
                  name="dp" ngbDatepicker #datepicker="ngbDatepicker" placement="bottom-left">

              <button class="btn btn-primary" type="button" (click)="datepicker.toggle()">
                <span class="material-icons-round">event</span>
              </button>
          </div>
      </fieldset>
  </div>
</div>
  `
})
export class PopupDatePickerComponent {

  @Input()
  minDate = moment().subtract(120, 'year').toDate();

  @Input()
  maxDate = moment().toDate();

  @Input()
  formGroup: FormGroup;

  @Input()
  fGroupName: string;

  @Input()
  fieldSetName: string;

  @Input()
  fControlName: string;

  @ViewChild('datepicker')
  datepicker: NgbDatepicker;

  @Input()
  readonly = 'true';

  @Input()
  placeholder = 'mm/dd/yyyy';

  @Input()
  extraCss = '';

  value: string;

  constructor(private adapter: NgbDateNativeAdapter, private localDateParserFormatter: NgbLocalDateParserFormatter) { }

  convert(date: Date): NgbDateStruct {
    return this.adapter.fromModel(date);
  }

  toUSShortDateFormatString(ngbDate: NgbDateStruct): string {
    return this.localDateParserFormatter.format(ngbDate);
  }
}
